import { TFunction } from 'i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { DocumentTabEnum } from '../enums';

type Args = {
  allCount?: number;
  favoritesCount?: number;
  t: TFunction<'translation', undefined>;
  unreadCount?: number;
};

export default function getTableTabs({
  allCount,
  favoritesCount,
  t,
  unreadCount,
}: Args) {
  const favoritesLabel = (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <MaterialIcon icon="bookmark_star" symbolsOutlined filled block />
    </span>
  );

  return [
    {
      label: t('all'),
      value: DocumentTabEnum.All,
      counter: allCount,
    },
    {
      label: t('unread'),
      value: DocumentTabEnum.Unread,
      counter: unreadCount,
    },
    {
      label: favoritesLabel,
      value: DocumentTabEnum.Favorites,
      counter: favoritesCount,
    },
  ];
}
